export default __webpack_public_path__ + "static/media/bidifylogo_arbitrum.8058e0bb.png";